import { EmployeeBreach as EmployeeBreachDto } from '@electricjs/core_entity-client';

import {
  MarkEmployeeBreachResolvedResponse,
  ResolveEmployeeBreachArgs,
} from '@/redux/slices/employeeBreachApiSlice';
import {
  EmployeeBreachesResults,
  BreachInfo,
  EmployeeInfo,
  EmployeeBreachResult,
} from '@/types/employeeBreach';

const adobeBreach: BreachInfo = {
  id: '24f05303-fd0a-4f5f-995c-0ba756697e16',
  name: 'Adobe',
  displayName: 'Adobe',
  domainUrl: 'adobe.com',
  dataClasses: ['Email addresses', 'Password hints', 'Passwords', 'Usernames'],
  logoUrl: 'https://haveibeenpwned.com/Content/Images/PwnedLogos/Adobe.png',
  breachedAt: '2013-10-04',
};

const canvaBreach: BreachInfo = {
  id: '24f05303-fd0a-4f5f-995c-0ba756697e17',
  name: 'Canva',
  displayName: 'Canva',
  domainUrl: 'canva.com',
  dataClasses: [
    'Email addresses',
    'Geographic locations',
    'Names',
    'Passwords',
    'Usernames',
  ],
  logoUrl: 'https://haveibeenpwned.com/Content/Images/PwnedLogos/Canva.png',
  breachedAt: '2019-05-24',
};

const dropboxBreach = {
  id: '24f05303-fd0a-4f5f-995c-0ba756697e18',
  name: 'Dropbox',
  displayName: 'Dropbox',
  domainUrl: 'dropbox.com',
  dataClasses: ['Email addresses', 'Passwords'],
  logoUrl: 'https://haveibeenpwned.com/Content/Images/PwnedLogos/Dropbox.png',
  breachedAt: '2012-07-01',
};

const limevpnBreach = {
  id: '24f05303-fd0a-4f5f-995c-0ba756697e19',
  name: 'LimeVPN',
  displayName: 'LimeVPN',
  domainUrl: 'limevpn.com',
  dataClasses: [
    'Email addresses',
    'IP addresses',
    'Names',
    'Passwords',
    'Phone numbers',
    'Physical addresses',
    'Purchases',
  ],
  logoUrl: 'https://haveibeenpwned.com/Content/Images/PwnedLogos/LimeVPN.png',
  breachedAt: '2020-10-08',
};

const linkedInBreach = {
  id: '24f05303-fd0a-4f5f-995c-0ba756697e20',
  name: 'LinkedIn',
  displayName: 'LinkedIn',
  domainUrl: 'linkedin.com',
  dataClasses: ['Email addresses', 'Passwords'],
  logoUrl: 'https://haveibeenpwned.com/Content/Images/PwnedLogos/LinkedIn.png',
  breachedAt: '2012-05-05',
};

const luminpdfBreach = {
  id: '24f05303-fd0a-4f5f-995c-0ba756697e21',
  name: 'LuminPDF',
  displayName: 'Lumin PDF',
  domainUrl: 'luminpdf.com',
  dataClasses: [
    'Auth tokens',
    'Email addresses',
    'Genders',
    'Names',
    'Passwords',
    'Spoken languages',
    'Usernames',
  ],
  logoUrl: 'https://haveibeenpwned.com/Content/Images/PwnedLogos/LuminPDF.png',
  breachedAt: '2019-04-01',
};

const johnDoe: EmployeeInfo = {
  email: 'john.doe@demo.electric.ai',
  firstName: 'John',
  lastName: 'Doe',
  id: 'a146d50f-6e0f-455c-9e00-b71380d09322',
};

const janeDoe: EmployeeInfo = {
  email: 'jane.doe@demo.electric.ai',
  firstName: 'Jane',
  lastName: 'Doe',
  id: 'a146d50f-6e0f-455c-9e00-b71380d09323',
};

const joeDoe: EmployeeInfo = {
  email: 'joe.doe@demo.electric.ai',
  firstName: 'Joe',
  lastName: 'Doe',
  id: 'a146d50f-6e0f-455c-9e00-b71380d09324',
};

const jillDoe: EmployeeInfo = {
  email: 'jill.doe@demo.electric.ai',
  firstName: 'Jill',
  lastName: 'Doe',
  id: 'a146d50f-6e0f-455c-9e00-b71380d09325',
};

const johnDoeBreaches: EmployeeBreachesResults = [
  {
    employee: johnDoe,
    breach: linkedInBreach,
    createdAt: '2024-08-12T11:17:36.123Z',
  },
  {
    employee: johnDoe,
    breach: canvaBreach,
    createdAt: '2024-08-11T11:17:36.123Z',
  },
];

const janeDoeBreaches: EmployeeBreachesResults = [
  {
    employee: janeDoe,
    breach: adobeBreach,
    createdAt: '2024-08-09T11:17:36.123Z',
  },
  {
    employee: janeDoe,
    breach: canvaBreach,
    createdAt: '2024-08-10T11:17:36.123Z',
  },
];

const joeDoeBreaches: EmployeeBreachesResults = [
  {
    employee: joeDoe,
    breach: limevpnBreach,
    createdAt: '2024-08-12T10:17:36.123Z',
  },
  {
    employee: joeDoe,
    breach: luminpdfBreach,
    createdAt: '2024-07-12T11:17:36.123Z',
  },
  {
    employee: joeDoe,
    breach: dropboxBreach,
    createdAt: '2024-07-30T11:17:36.123Z',
  },
];

const jillDoeBreaches: EmployeeBreachesResults = [
  {
    employee: jillDoe,
    breach: linkedInBreach,
    createdAt: '2024-05-12T11:17:36.123Z',
  },
  {
    employee: jillDoe,
    breach: canvaBreach,
    createdAt: '2024-06-12T11:17:36.123Z',
  },
  {
    employee: jillDoe,
    breach: dropboxBreach,
    createdAt: '2024-07-09T11:17:36.123Z',
  },
  {
    employee: jillDoe,
    breach: adobeBreach,
    createdAt: '2024-08-04T11:17:36.123Z',
  },
];

export const mockDataBreachData: EmployeeBreachesResults = [
  ...johnDoeBreaches,
  ...janeDoeBreaches,
  ...joeDoeBreaches,
  ...jillDoeBreaches,
];

export const markMockBreachResolved = (
  args: ResolveEmployeeBreachArgs
): MarkEmployeeBreachResolvedResponse => {
  const { breachId, employeeId } = args;
  const employeeBreach: EmployeeBreachResult | undefined =
    mockDataBreachData.find(
      x => x.breach.id === breachId && x.employee.id === employeeId
    );

  if (employeeBreach !== undefined) {
    employeeBreach.resolvedAt = new Date().toISOString();
  }

  return Promise.resolve({});
};

// Inverse of the slice's `mapEmployeeBreach`, so handlers serve the same fixtures
// the UI-level mocks use (including resolved state set by `markMockBreachResolved`).
export const toEmployeeBreachDto = (
  result: EmployeeBreachResult
): EmployeeBreachDto => ({
  employee: {
    id: result.employee.id,
    first_name: result.employee.firstName,
    last_name: result.employee.lastName,
    email: result.employee.email,
  },
  breach: {
    id: result.breach.id,
    name: result.breach.name,
    display_name: result.breach.displayName,
    domain_url: result.breach.domainUrl,
    data_classes: result.breach.dataClasses,
    logo_url: result.breach.logoUrl,
    breached_at: result.breach.breachedAt,
  },
  resolved_at: result.resolvedAt,
  resolved_by: result.resolvedBy,
  created_at: result.createdAt,
  updated_at: result.updatedAt,
});
